import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TextField } from '@mui/material';
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const DateTimePicker = (props) => {
	const { value, onChange, style, label, minutesStep, ...rest } = props;

	const [open, setOpen] = useState(false);

	const defaultSx = { width: '100%', backgroundColor: 'white' };

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<MuiDateTimePicker
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				renderInput={(p) => (
					<TextField
						{...p}
						fullWidth
						onClick={(e) => setOpen(true)}
						{...rest}
					/>
				)}
				format="YYYY-MM-DD HH:mm"
				value={!value ? null : moment.utc(value)}
				onChange={onChange}
				ampm={false}
				variant="inline"
				inputVariant="outlined"
				label={label}
				minutesStep={minutesStep ?? 30}
				sx={style ? style : defaultSx}
				{...rest}
			/>
		</LocalizationProvider>
	);
};
DateTimePicker.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	label: PropTypes.string,
	minutesStep: PropTypes.number
};

export default DateTimePicker;
